module.exports = __webpack_public_path__ + "static/media/PlanThumb.9c88ad09.png";